module.exports = __webpack_public_path__ + "public/img/20.3052e4fa.png";